// Delarmente brand palette (see ui_ux/delarmente-design-system).
// Puso Red leads, Serbisyo Green supports, warm Sampaguita paper background.
export default {
  presets: {
    light: {
      primary: '#D7263D', // Puso Red
      secondary: '#166534', // Serbisyo Green
      backgroundPrimary: '#FFFDF8', // Sampaguita (page)
      backgroundSecondary: '#FFFFFF', // navbar / sidebar / cards
      backgroundElement: '#FBE9EB', // Blush (subtle red tint)
      backgroundBorder: '#E4DED2', // Line
      textPrimary: '#1F2D24', // Ink
      textInverted: '#FFFDF8',
      backgroundCardPrimary: '#FFFFFF',
      backgroundCardSecondary: '#E9F3EC', // Palm (green tint)
      success: '#166534',
      info: '#158DE3',
      danger: '#A81C2F', // Puso Deep
      warning: '#F4A521',
      focus: '#D7263D',
    },
    dark: {
      primary: '#E23A4E',
      secondary: '#2E9E5B',
      backgroundPrimary: '#1F2D24', // Ink
      backgroundSecondary: '#26332B',
      backgroundCardPrimary: '#26332B',
      backgroundCardSecondary: '#2E3D33',
      success: '#3FA76A',
      info: '#158DE3',
      danger: '#E23A4E',
      warning: '#F4A521',
    },
  },
}
